if (!customElements.get('product-specifications')) {
  customElements.define(
    'product-specifications',
    class ProductSpecifications extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.weights = this.parseWeights();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId) return;
          this.updateWeight(data.variant?.id);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      parseWeights() {
        try {
          return JSON.parse(this.querySelector('[data-product-variant-weights]')?.textContent || '{}');
        } catch {
          return {};
        }
      }

      updateWeight(variantId) {
        const row = this.querySelector('[data-product-weight-row]');
        const value = this.querySelector('[data-product-weight]');
        const weight = this.weights[String(variantId)];
        const hasWeight = Number(weight?.value) > 0;

        row?.classList.toggle('hidden', !hasWeight);
        if (value) value.textContent = hasWeight ? `${weight.value} ${weight.unit}` : '';
      }
    }
  );
}
